module.exports = __webpack_public_path__ + "img/mockAndroidHead.3176be.png";